/*
if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
        constructor() {
        super();

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                updateRecommendProductTitle();  
                }
            })
            .catch(e => {
                console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);
    
    function updateRecommendProductTitle() {  
        const recommendProduct = document.querySelector('.product-recommendations');  
        if (recommendProduct) {  
            const recommendProductTitle = recommendProduct.querySelector('.related_category_title');  
            const subcategoryUrl = recommendProduct.querySelector('.subcategory_url');
            const storedTitle = localStorage.getItem('collection_title'); 
            const storedUrl = localStorage.getItem('collection_url'); 
            console.log(storedUrl, "here==>");  
            recommendProductTitle.textContent = storedTitle;  
            subcategoryUrl.href = storedUrl;
        }  
    }  
        const productCard = document.querySelectorAll('.product-grid .card_align');  
        productCard.forEach(card => {  
            card.addEventListener('click', function(e){  
                const collectionTitleElement = card.closest('.collection--container').querySelector('.collection-title--identify');
                const collectionUrlElement = card.closest('.collection--container').querySelector('.collection-url--identify');  
                if (collectionTitleElement && collectionUrlElement) {  
                    const collectionTitle = collectionTitleElement.textContent.trim();  
                    const collectionUrl = collectionUrlElement.value;
                    localStorage.setItem('collection_title', collectionTitle); 
                    localStorage.setItem('collection_url', collectionUrl); 
                }  
            });  
        });  

}



*/
document.addEventListener("DOMContentLoaded", function () {
    const richText = document.querySelector(".rich-text__text.rte");
    
    if (richText) {
        const paragraphs = richText.querySelectorAll("p");

        if (paragraphs.length > 1) {
            const seeMoreBtn = document.createElement("button");
            seeMoreBtn.textContent = "See More";
            seeMoreBtn.classList.add("see-more-btn");

            richText.insertAdjacentElement("afterend", seeMoreBtn);

            seeMoreBtn.addEventListener("click", function () {
                richText.classList.toggle("expanded");
                seeMoreBtn.textContent = richText.classList.contains("expanded") 
                    ? "See Less" 
                    : "See More";
            });
        }
    }
});
document.addEventListener('DOMContentLoaded', function() {

  const modalButtons = document.querySelectorAll(".back-in-stock-button");
  const modals = document.querySelectorAll(".klaviyo-modal");
  const closeButtons = document.querySelectorAll(".notify_modal__close");
  let parentClass = null;

modalButtons.forEach(button => {
  button.addEventListener("click", function() {
    const modalId = button.getAttribute('data-modal-id');
    const modal = document.getElementById(modalId);
    const gridItem = modal.closest('.grid__item');
    const subscribeModal = modal.querySelector('.klaviyo-modal-content');
    const successModal = modal.querySelector('.klaviyo-modal-success-content');
    parentClass = button.closest('.pdes_innder');
    if(gridItem) {
      const collectionContainer = document.querySelector('.collection_grid');
      if (collectionContainer) {
        collectionContainer.appendChild(modal);
      }
    }
    modal.style.display = "block";  
    subscribeModal.classList.remove('hidden');
    successModal.classList.add('hidden');
  });
});

closeButtons.forEach(button => {
  button.addEventListener("click", function() {
    const modal = button.closest('.klaviyo-modal');
    modal.style.display = "none";
    if (parentClass) {
      const modalButton = parentClass.querySelector('.back-in-stock-button');
      if(modalButton) {
        parentClass.insertBefore(modal, modalButton.nextSibling);
      }
    }
  });
});

window.addEventListener("click", function(event) {
  modals.forEach(modal => {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  });
});


const forms = document.querySelectorAll("#back-in-stock-form");
forms.forEach(form => {
  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    const variantId = form.querySelector("#restock-variant-id").value;
    const email = form.querySelector('.restock-email').value.trim();
    const phone = form.querySelector('.restock-phone').value.trim();
    const publicApiKey = "VHR3bz"; // Replace with your actual PUBLIC API KEY
    const listId = "WPP7NK"; // Replace with your actual SMS-enabled List ID
  
    console.log("Email entered:", email);
    console.log("Variant ID entered:", variantId);
  
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhone = /^\+\d{10,15}$/.test(phone); // E.164 format
  
    console.log("Email valid?", isValidEmail);
    console.log("Phone valid?", isValidPhone);
  
    if (!isValidEmail || !variantId) {
      alert("Please provide a valid email and ensure a product variant is selected.");
      return;
    }
  
    const channels = ["EMAIL"];
    const profileAttributes = { email };
  
    // ✅ Step 1: Get SMS consent if phone is valid
    if (isValidPhone) {
      try {
        const smsConsentPayload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    phone_number: phone
                  }
                }
              },
              custom_source: "Back in Stock"
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        };
  
        const smsConsentResponse = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${publicApiKey}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-06-15"
          },
          body: JSON.stringify(smsConsentPayload)
        });
  
        if (!smsConsentResponse.ok) {
          const errorData = await smsConsentResponse.json();
          console.error("SMS consent error:", errorData);
          alert("Failed to get SMS consent. Please try again.");
          return;
        }
  
        // SMS consent was successful
        channels.push("SMS");
        profileAttributes.phone_number = phone;
      } catch (error) {
        console.error("SMS consent fetch error:", error);
        alert("An unexpected error occurred while processing SMS consent.");
        return;
      }
    }
    
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: channels,
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
  
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2024-06-15"
      },
      body: JSON.stringify(payload)
    };
  
    const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicApiKey}`, requestOptions)
        .then(
            result => {
            console.log(result)
            if(result.ok) {
                const SuccessModal = form.closest('.klaviyo-modal').querySelector('.klaviyo-modal-success-content');
                const subscribeModal = form.closest('.klaviyo-modal').querySelector('.klaviyo-modal-content');
                subscribeModal.classList.add('hidden');
                SuccessModal.classList.remove('hidden');
            }
        })
        .catch(error => console.log('error', error))
});

});

});



document.addEventListener("DOMContentLoaded", function () {
  const ratingBoxes = document.querySelectorAll(".gr-rate-sold .product-rating");

  ratingBoxes.forEach(box => {
    const rating = parseFloat(box.dataset.rating);
    const stars = box.querySelectorAll(".stars span");

    stars.forEach((star, i) => {
      star.classList.remove("active");
      star.style.background = "none";
      star.style.webkitTextFillColor = "";
      star.style.webkitBackgroundClip = "unset";

      if (rating >= i + 1) {
        star.classList.add("active");
      } else if (rating > i) {
        const percent = ((rating - i) * 100).toFixed(1);
        star.style.background = `linear-gradient(90deg, gold ${percent}%, #ccc ${percent}%)`;
        star.style.webkitBackgroundClip = "text";
        star.style.webkitTextFillColor = "transparent";
      }
    });
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const fill = document.querySelector('.ship-fill');
  const msg = document.querySelector('.ship-msg');
  const total = document.querySelector('.ship-total');

  const t1 = 5900, t2 = 20000; // Removed t3 (27900) for free shipping

  function updateProgress(cart) {
    const totalPrice = cart.total_price || 0;
    
    if (total) total.textContent = formatMoney(totalPrice);
    // Use t2 as the maximum for progress calculation
    if (fill) fill.style.width = Math.min(100, (totalPrice / t2) * 100) + '%';
    updateMsg(totalPrice);
  }

  function updateMsg(totalPrice) {
    if (!msg) return;

    const need1 = formatMoney(t1 - totalPrice);
    const need2 = formatMoney(t2 - totalPrice);

    let html = '';
    if (totalPrice < t1) {
      html = `<p>Add <strong>${need1}</strong> for NYC Delivery</p>
              <p>Spend <strong>${need2}</strong> for $25 credit</p>`;
    } else if (totalPrice < t2) {
      html = `<p class="done">✓ Free NYC Delivery </p>
              <p>Add <strong>${need2}</strong> for $25 credit<span class="note">*</span></p>`;
    } else {
      html = `<p class="done">✓ NYC Delivery</p>
              <p class="done">🎉 Up to $25 credit unlocked!</p>`;
    }

    msg.innerHTML = html;
  }

  function formatMoney(amount) {
    if (amount <= 0) return '$0.00';
    return '$' + (amount / 100).toFixed(2);
  }

  function getCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(updateProgress)
      .catch(e => console.error('Cart error:', e));
  }

  getCart();
  document.addEventListener('ajaxCart.afterCartLoad', getCart);
  
  ['click', 'change'].forEach(e => {
    document.body.addEventListener(e, function(ev) {
      if (ev.target.closest('[href*="cart"], [name="add"], [name="updates[]"], .cart-item, #Remove-')) {
        setTimeout(getCart, 300);
      }
    });
  });
});